// src/components/studentPortal/TasksAndCertificates.jsx
// Section 3 of the Student Portal. UI SHELL ONLY - static mock data below,
// no backend. Explicitly deferred by the owner until the business analyst
// report; do not wire this to anything real without that sign-off.
import React from 'react';
import { FiAward, FiLock, FiDownload } from 'react-icons/fi';

const MOCK_PROGRESS = [
  { key: 'foundations', label: 'Filmmaking Foundations', percent: 100 },
  { key: 'preproduction', label: 'Pre-Production Essentials', percent: 65 },
  { key: 'onset', label: 'On-Set Workflow', percent: 30 },
  { key: 'postproduction', label: 'Post-Production Basics', percent: 0 },
];

const MOCK_CERTIFICATES = [
  { key: 'foundations', label: 'Filmmaking Foundations', unlocked: true },
  { key: 'preproduction', label: 'Pre-Production Essentials', unlocked: false },
  { key: 'onset', label: 'On-Set Workflow', unlocked: false },
  { key: 'postproduction', label: 'Post-Production Basics', unlocked: false },
];

const ProgressCard = ({ label, percent }) => (
  <div className="rounded-2xl border border-slate-200 bg-white p-4">
    <div className="flex items-center justify-between mb-2">
      <p className="text-sm font-semibold text-slate-800">{label}</p>
      <span className="text-xs font-medium text-slate-500">{percent}%</span>
    </div>
    <div className="h-2 rounded-full bg-slate-100 overflow-hidden">
      <div
        className="h-full rounded-full bg-gradient-to-r from-teal-500 to-cyan-500 transition-all duration-500"
        style={{ width: `${percent}%` }}
      />
    </div>
  </div>
);

const CertificateBadge = ({ label, unlocked }) => (
  <div
    className={`rounded-2xl border p-4 flex flex-col items-center text-center gap-2 transition-all duration-200 ${
      unlocked ? 'border-teal-200 bg-teal-50' : 'border-slate-200 bg-slate-50'
    }`}
  >
    <div
      className={`w-14 h-14 rounded-full flex items-center justify-center ${
        unlocked ? 'bg-gradient-to-br from-teal-500 to-cyan-500 text-white' : 'bg-slate-200 text-slate-400 grayscale'
      }`}
    >
      {unlocked ? <FiAward size={22} /> : <FiLock size={18} />}
    </div>
    <p className={`text-sm font-medium ${unlocked ? 'text-slate-800' : 'text-slate-400'}`}>{label}</p>
    {unlocked ? (
      <button className="flex items-center gap-1 text-xs font-medium text-teal-700 hover:text-teal-800 mt-1">
        <FiDownload size={12} /> Download
      </button>
    ) : (
      <p className="text-[11px] text-slate-400 mt-1">Complete the course to unlock</p>
    )}
  </div>
);

const TasksAndCertificates = () => (
  <div>
    <h2 className="text-xl font-bold text-slate-800 mb-4">Tasks and Certificates</h2>

    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8">
      {MOCK_PROGRESS.map((p) => <ProgressCard key={p.key} label={p.label} percent={p.percent} />)}
    </div>

    <h3 className="text-sm font-semibold text-slate-700 mb-3">Certificates</h3>
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
      {MOCK_CERTIFICATES.map((c) => <CertificateBadge key={c.key} label={c.label} unlocked={c.unlocked} />)}
    </div>
  </div>
);

export default TasksAndCertificates;
